module.exports = __webpack_public_path__ + "static/media/receipt.60bf68d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/receipt.svg
// module id = 758
// module chunks = 11